import React, { FunctionComponent, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./Integration.module.css";
import { themeColors } from "../../Components/theme";
import { autoCreateApi, fetchAndSetOrgCountry, fetchApi } from "../../Services/organizations";
import { showSnackbarAction } from "../../Redux/actions";
import { useLocation } from 'react-router-dom';
import FaceBookCrm from "../../Assets/Images/housingpreview.png";
import Loading from "../../Components/Loading/Loading";
// Import theme variables
import "../../theme-vars.css";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useMediaQuery } from "@mui/material";

type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
  facebookUesrPageList: any;
  organizationId: any
};
interface LocationState {
  data: any;
}

const Housing: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme,
  facebookUesrPageList,
  organizationId
}) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const dispatcher = useDispatch();
  const location = useLocation();
  const state = location.state as LocationState || {};
  const [API, setAPI] = useState<any[] | undefined>(undefined);
  const [load, setLoad] = useState(false);
  const [APIKey, setAPIKey] = useState("");
  const [copied, setCopied] = useState(false);
  const [countryCode, setcountryCode] = useState("+91");

  useEffect(() => {
    fetchAndSetOrgCountry(user.organization_id, (val) => setcountryCode(val));
  }, []);

  useEffect(() => {
    if (user.organization_id) {
      fetchApi(user.organization_id, (val) => setAPI(val));
    }
  }, [user.organization_id]);

  useEffect(() => {
    if (API !== undefined && API.length > 0) {
      const filteredData = API && API.filter(item => item.source === "Housing");
      if (filteredData && filteredData.length > 0) {
        setAPIKey(filteredData[0].api_key)
      }
      const filterValue = API.some(item => item.source === "Housing");
      const leadSourceFilter = state.data.some(
        (item: any) => item.leadSource?.toLowerCase() === "Housing".toLowerCase()
      );
      const leadSourceFilterData = state?.data?.filter(
        (item: any) => item.leadSource?.toLowerCase() === "Housing".toLowerCase()
      );
      if (!leadSourceFilter) {
        dispatcher(showSnackbarAction("Before configuring the lead source in 'Housing,' ensure it is added to the resources!!", "error"));
        return;
      }
      if (!filterValue) {
        autoCreateApi(
          organizationId,
          "Housing",
          leadSourceFilterData[0]?.leadSource_id,
          countryCode,
        );
      }
    }
  }, [API]);

  const bodyData = {
    'customer_name': "",
    'contact_no': "",
    'email': "",
    'country_code': "",
    'project': "",
    'campaign': "Housing",
    'token': APIKey
  }
  const jsonBodyData = JSON.stringify(bodyData, null, 2);

  const handleCopyJson = () => {
    navigator.clipboard.writeText(jsonBodyData);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    fontFamily: "var(--font-family-main)",
    fontSize: "var(--font-size-small)"
  };

  return (
    <>
      <div
        className={styles.parent}
        style={{ ...containerStyles, marginTop: isMobile ? "5%" : "4%", overflow: "hidden", maxHeight: "500px", overflowY: "scroll", marginBottom: "20px", }}
      >
        {load && <Loading />}
        <div style={{ width: "80%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", margin: "20px 20px 80px 50px", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
          <div style={{ fontSize: "var(--font-size-large)", fontWeight: "500", margin: "20px 0px 20px 0px", fontFamily: "var(--font-family-main)" }}>
            Housing.com Integration
          </div>
          <div style={{ width: "80%", display: "flex", alignItems: "flex-start", justifyContent: "flex-start", flexDirection: "column", marginBottom: "50px" }}>
            <p style={{ margin: 0, padding: 0, fontWeight: 600, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Receive new leads from Housing.com in your Leads Rubix account.</p>
            <p style={{ fontSize: "var(--font-size-small)", margin: 0.3, padding: 0.3, fontFamily: "var(--font-family-main)" }}>Forward Instructions to your Account Manager.</p>
            <p style={{ fontSize: "var(--font-size-small)", margin: 0.3, padding: 0.3, fontFamily: "var(--font-family-main)" }}>Connect to Leads Rubix by submitting a request directly to your Housing.com account manager.</p>
            <p style={{ fontSize: "var(--font-size-small)", marginTop: "5px", padding: 0, fontFamily: "var(--font-family-main)" }}>Please forward them the following instructions, making sure to replace YOUR_EMAIL and YOUR_PHONE_NUMBER with your Housing.com registered account details:</p>
            <div style={{ backgroundColor: theme ? "lightgray" : "rgb(39, 41, 68)", width: "100%" }}>
              <div style={{ margin: "10px 10px 10px 10px", textAlign: "center", position: "relative", fontFamily: "var(--font-family-main)" }}>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600, fontSize: "var(--font-size-medium)" }}>
                  Integration Request:
                </p>
                <p style={{ margin: 0.3, padding: 0.3 }}>
                  Please configure my Housing.com account to send all leads directly to Leads Rubix CRM.
                </p>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600, fontSize: "var(--font-size-medium)" }}>
                  My Housing.com Account Details:
                </p>
                <p style={{ margin: 0.3, padding: 0.3 }}>
                  Email Address: YOUR_EMAIL
                </p>
                <p style={{ margin: 0.3, padding: 0.3 }}>
                  Registered Phone Number: YOUR_PHONE_NUMBER
                </p>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600, fontSize: "var(--font-size-medium)" }}>
                  Webhook Details:
                </p>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 500 }}>
                  Webhook URL:
                </p>
                <p style={{ margin: 0.3, padding: 0.3 }}>
                  https://us-central1-leads-rubix.cloudfunctions.net/api-createContacts
                </p>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 500 }}>
                  Method: POST
                </p>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600 }}>
                  Payload Parameters:
                </p>
                <div style={{ position: "relative", textAlign: "left", marginTop: 8, fontFamily: "var(--font-family-main)" }}>
                  <ContentCopyIcon
                    onClick={handleCopyJson}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      cursor: "pointer",
                      color: copied ? "#272944" : "#555",
                      zIndex: 1,
                      fontSize: 16
                    }}
                    titleAccess={copied ? "Copied!" : "Copy JSON"}
                  />
                  <pre
                    style={{
                      background: "rgb(255, 250, 250)",
                      color: "#272944",
                      borderRadius: 4,
                      padding: "16px 40px 16px 16px",
                      fontSize: "var(--font-size-small)",
                      overflowX: "auto",
                      margin: 0,
                      fontFamily: "var(--font-family-main)"
                    }}
                  >
                    {jsonBodyData}
                  </pre>
                  {copied && (
                    <span style={{
                      position: "absolute",
                      top: 10,
                      right: 40,
                      color: "#272944",
                      fontSize: "var(--font-size-small)",
                      background: "#fff",
                      borderRadius: 4,
                      padding: "2px 8px",
                      fontFamily: "var(--font-family-main)"
                    }}>Copied!</span>
                  )}
                </div>
                <p style={{ margin: 0.3, padding: 0.3, fontWeight: 600, marginTop: 10, fontSize: "var(--font-size-medium)" }}>
                  Sample cURL Request (for push integration):
                </p>
                <div style={{ textAlign: "left", marginTop: 8, fontFamily: "var(--font-family-main)" }}>
                  <pre
                    style={{
                      background: "rgb(255, 250, 250)",
                      color: "#272944",
                      borderRadius: 4,
                      padding: "16px 16px",
                      fontSize: "var(--font-size-small)",
                      overflowX: "auto",
                      margin: 0,
                      fontFamily: "var(--font-family-main)"
                    }}
                  >{`curl --location --request POST 'https://us-central1-leads-rubix.cloudfunctions.net/api-createContacts' \\
--header 'Content-Type: application/json' \\
--data-raw '${jsonBodyData.replace(/\n/g, '\\n').replace(/'/g, "\\'")}'`}
                  </pre>
                </div>
              </div>
            </div>
            <p style={{ marginTop: "5px", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Your integration should be activated by the Housing.com team within a week's time. Once it is activated, you will start receiving leads directly in your Leads RUbix account.</p>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode,
    facebookUesrPageList: state.faceBookUserPagesData.data,
    organizationId: state.organization.id,
  };
};
export default connect(mapStateToProps)(Housing);
